import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { roomNameState } from '../../state/chatAtom';
import api from '../../api';
import './Header.css';

export default function Header() {
  const [roomName, setRoomName] = useRecoilState(roomNameState);

  useEffect(() => {
    const interval = setInterval(async () => {
      const params = new URLSearchParams(window.location.search);
      const roomUrl = params.get('roomUrl');

      if (roomUrl) {
        clearInterval(interval);

        const decoded = decodeURIComponent(roomUrl);

        const url = new URL(decoded);
        const segments = url.pathname.split('/');
        const roomId = segments.pop() || segments.pop();

        try {
          const response = await api.getRoomName(roomId);

          setRoomName(response?.name ?? 'Paskaita');
        } catch (error) {
          console.error('Failed to fetch room name:', error);
          setRoomName('Paskaita');
        }
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <header>
      <div className="header-section">
        <img className="logo" src="/images/logo.svg" alt="DigiGo" />
        <span className="title">{roomName}</span>
      </div>
    </header>
  );
}
